import "./RSAutocomplete.scss";

export default {
  root: "im-select",
  menu: "im-select__menu",
  menuList: "im-select__menu-list",
  valueContainer: "im-select__value-container",
  inputContainer: "im-select__input-container",
  placeholder: "im-select__placeholder",
  singleValue: "im-select__single-value",
  option: "im-select__option",
  menuNotice: "im-select__menu-notice",
  indicators: "im-select__indicators",
  indicator: "im-select__indicator",
  controlIsFocused: "im-select__control--is-focused",
};
